const EmailConfigTabs = Object.freeze({
  Subscribers: "subscribers",
  Unsubscribed: "unsubscribed",
  Settings: "settings",
});
export default EmailConfigTabs;
